import COLAL from './COLALs.Container';

export default COLAL;
